/**
 * DriveLinkForm — formulaire spécifique pour lier un dossier Google Drive
 * à un master_client + expertise (validation regex côté backend).
 *
 * Extrait de Bureau.jsx (Batch #14.221).
 */
import { useState } from "react";
import axios from "axios";
import { Loader2, Save } from "lucide-react";
import { toast } from "@/lib/toast";
import { API, authH } from "@/api";


export default function DriveLinkForm({ masterId, expertise, initialUrl, onCancel, onSaved }) {
  const [url, setUrl] = useState(initialUrl || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    const trimmed = (url || "").trim();
    if (!trimmed) {
      toast.error("Collez l'URL du dossier Drive");
      return;
    }
    setBusy(true);
    try {
      await axios.put(
        `${API}/masters/${masterId}/expertises/${expertise}/drive/link`,
        { folder_url: trimmed },
        { headers: authH() },
      );
      toast.success("Dossier Drive lié ✓");
      onSaved?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur — URL Drive invalide");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-3 space-y-2" data-testid="bureau-drive-link-form">
      <input
        type="url"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        placeholder="https://drive.google.com/drive/folders/..."
        className="w-full px-2.5 py-1.5 text-xs border border-indigo-200 rounded-lg focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 outline-none"
        data-testid="bureau-drive-link-input"
        autoFocus
      />
      <div className="flex items-center gap-1.5">
        <button
          onClick={save}
          disabled={busy}
          className="px-2.5 py-1.5 rounded-lg bg-indigo-600 text-white text-xs inline-flex items-center gap-1.5 hover:bg-indigo-700 disabled:opacity-40"
          data-testid="bureau-drive-link-save"
        >
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />}
          Enregistrer
        </button>
        <button
          onClick={onCancel}
          disabled={busy}
          className="px-2.5 py-1.5 rounded-lg border border-slate-300 text-slate-700 text-xs hover:bg-slate-50 disabled:opacity-40"
          data-testid="bureau-drive-link-cancel"
        >
          Annuler
        </button>
      </div>
      <div className="text-[10px] text-slate-400 leading-relaxed">
        💡 Astuce : créez (ou utilisez) un dossier dans votre Google Drive,
        copiez l'URL depuis la barre d'adresse, et collez-la ici.
      </div>
    </div>
  );
}
